<template>
  <div class="allOrder fl">
    <div class="title">
      <span
        :class="{'curspan':order_==index}"
        v-for="(order,index) in order_title"
        :key="index"
        @click="changeTab(index)"
      >{{order}}</span>
    </div>
    <div class="content">
        <div class="info clearfix">
           <span class="fl order_span">课程类型</span>
           <span class="fl order_span">课程名称</span>
           <span class="fl order_span">价格</span>
           <span class="fl order_span">支付方式</span>
           <span class="fl order_span">状态</span>
           <!-- <span class="fl order_span">电子发票</span> -->
        </div>
        <div class="total">
            <ul >
                <!-- <li class="clearfix neirong">
                    <p class="fl"><span>{{item.order_id}}</span></p>
                    <p class="fl guanword"><span>{{item.buy_obj}}</span></p>
                    <p class="fl monery">￥{{item.money}}元</p>
                    <p class="fl type">{{item.pay_type=='1'?"支付宝":item.pay_type=="2"?"微信":item.pay_type=="3"?"学时卡":"赠送"}}</p>
                    <p :class="item.status=='0'?'zhifu':'yizhifu'">{{item.status=='0'?"未支付":item.status=="1"?"已支付":"支付失败"}}</p>
                    <p class="fr"><span>{{item.time}}</span></p>
                </li> -->
                <li class="clearfix order_li" v-for="(item,index) in data" :key="index">
                    <p><span>订单号：{{item.order_id}}</span><span>下单时间：{{item.time}}</span></p>
                    <div>
                        <img :src="item.img_url" alt="">
                        <div>
                            <span>{{item.kecheng_name}}({{item.type==3?'课程':"课程包"}})</span><br>
                            <!-- <span>目标学时：</span><span>30(必修不少于24)</span> -->
                        </div>
                        <div>￥{{item.money}}元</div>
                        <div>{{item.pay_type==3?"学时卡支付":item.pay_type==2?"微信支付":"支付宝支付"}}</div>
                        <div>{{item.status=='0'?"未支付":item.status=="1"?"已支付":"支付失败"}}</div>
                        <!-- <div>
                            <span>查看详情</span>
                            <span>{{item.status=='0'?"无法打印":item.status=="1"?"打印发票":"支付失败"}}</span>
                            <span>删除订单</span>
                        </div> -->
                    </div>

                    <!-- <span class="fl spn1" style="text-align:left;">{{item.order_id}}</span>
                    <span class="fl spn2" :title="item.buy_obj">{{item.buy_obj}}({{item.type==1?'课程包':"课程"}})</span>
                    <span class="fl spn3">￥{{item.money}}元</span>
                    <span class="fl spn4">{{item.pay_type=='1'?"支付宝":item.pay_type=="2"?"微信":item.pay_type=="3"?"学时卡":"赠送"}}</span>
                    <span class="fl spn5" :class="item.status=='0'?'zhifu':'yizhifu'">{{item.status=='0'?"未支付":item.status=="1"?"已支付":"支付失败"}}</span>
                    <span class="fl spn6">{{item.time}}</span> -->

                </li>

            </ul>
            <div class="nodata" v-show="nodata">
               </div>
          <div class="block" style="text-align:center;margin-top:10px;">
            <el-pagination
                background
                layout="total,prev, pager, next,jumper"
                :page-size="14"
                :total="count"
                @current-change="handleCurrentChange"
                :current-page.sync="pageNo"
                :page-count='5'
                v-show="count>14"
                >
            </el-pagination>
            </div>


        </div>
    </div>
  </div>
</template>

<script>
import qs from 'qs'
export default {
    data (){
        return {
            uid:'',
            token:'',
            page:1,
            pageNo:1,
            num:14,
            count:0,
            data:[],
            pagevalue:false,
            // currentPage:1
            
            nodata:true,
            order_title:['全部订单',
            /* '专业课','公需课', */
            ],
            order_:0
        }
    },
    created (){
        this.uid= localStorage.getItem('uid')
        this.token=localStorage.getItem('token')
        // //console.log(this.uid,this.token)

        if(this.token){
            this.getOrder()
        }else{
            this.removeInfo()
        }
        this.zhuanye()
    },
    watch: {
		token: {
			handler: function(val) {
                if (val) {

                }else{
                    this.removeInfo()
                }
			}
		},deep:true
	},
    methods:{
        changeTab: function(index) {
            this.order_ = index;
            sessionStorage.setItem('order_',this.order_)
        if (index == 0) {
            this.kemuid = "";
            this.page=1;
            this.zhuanye();
        } else if (index == 1) {
            this.kemuid = 1;
            this.page=1;
            this.zhuanye_z();
        } else if (index == 2) {
            this.kemuid = 2;
            this.page=1;
            this.zhuanye_g();
        }
    },
    //获取我的专业课订单
    zhuanye_z(){
        var that=this
        var order_data={
            uid:this.uid,
            token:this.token,
            page:this.page,
            num:this.num,
            type:'1'
        }
        this.$axios.post('/pay/get_pay_order',
            qs.stringify(order_data)
            ).then(res =>{
                if(res.data.status=="ok"){
                    that.count=Number(res.data.data.count);
                    // if(that.count/6>1){
                    //     that.pagevalue=true;
                    // }
                    that.data=[]
                    that.data=that.data.concat(res.data.data.data)
                    // //console.log( that.data)
                    if(that.count>0){
                        that.nodata=false
                    }else{
                        that.nodata=true
                    }
                }else if((res.data.status=="error")){
                    this.$message.error({message:res.data.errormsg,duration:1600});
                }
                // if((res.data.status=="relogin")){
                //     this.$message.error({message:"重新登录",duration:1600});
                //     // that.removeInfo();
                // }
            })

    },
    //获取我的公需课订单
    zhuanye_g(){
        var that=this
        var order_data={
            uid:this.uid,
            token:this.token,
            page:this.page,
            num:this.num,
            type:'2'
        }
        this.$axios.post('/pay/get_pay_order',
            qs.stringify(order_data)
            ).then(res =>{
                if(res.data.status=="ok"){
                    that.count=Number(res.data.data.count);
                    // if(that.count/6>1){
                    //     that.pagevalue=true;
                    // }
                    that.data=[]
                    that.data=that.data.concat(res.data.data.data)
                    // //console.log( that.data)
                    if(that.count>0){
                        that.nodata=false
                    }else{
                        that.nodata=true
                    }
                }else if((res.data.status=="error")){
                    this.$message.error({message:res.data.errormsg,duration:1600});
                }
                // if((res.data.status=="relogin")){
                //     this.$message.error({message:"重新登录",duration:1600});
                //     // that.removeInfo();
                // }
            })

    },
    //获取我的全部订单
    zhuanye(){
        var that=this
        var order_data={
            uid:this.uid,
            token:this.token,
            page:this.page,
            num:this.num,
        }
        this.$axios.post('/pay/get_pay_order',
            qs.stringify(order_data)
            ).then(res =>{
                if(res.data.status=="ok"){
                    that.count=Number(res.data.data.count);
                    // if(that.count/6>1){
                    //     that.pagevalue=true;
                    // }
                    that.data=[]
                    that.data=that.data.concat(res.data.data.data)
                    // //console.log( that.data)
                    if(that.count>0){
                        that.nodata=false
                    }else{
                        that.nodata=true
                    }
                }else if((res.data.status=="error")){
                    this.$message.error({message:res.data.errormsg,duration:1600});
                }
                // if((res.data.status=="relogin")){
                //     this.$message.error({message:"重新登录",duration:1600});
                //     // that.removeInfo();
                // }
            })

    },
        removeInfo(){
            var that=this
            localStorage.removeItem("uid");
            localStorage.removeItem("token");
            localStorage.removeItem("sex");
            localStorage.removeItem("name");
            localStorage.removeItem("mobile");
            localStorage.removeItem("id_card");
            setTimeout(() => {
            that.$router.push({ path: '/' });
            }, 1600);
        },
        getOrder (){
            // //console.log('112121212')
            var that=this
            var data={
                uid:this.uid,
                token:this.token,
                page:this.page,
                num:this.num,
            }
            this.$axios.post('/pay/get_pay_order',
            qs.stringify(data)
            ).then(res =>{
                // //console.log(res)
                if(res.data.status=="ok"){
                    that.count=Number(res.data.data.count);
                    // if(that.count/6>1){
                    //     that.pagevalue=true;
                    // }
                    that.data=[]
                    that.data=that.data.concat(res.data.data.data)
                    // //console.log( that.data)
                     if(that.count>0){
                        that.nodata=false
                    }else{
                        that.nodata=true
                    }
                }else if((res.data.status=="error")){
                    this.$message.error({message:res.data.errormsg,duration:1600});
                }else if((res.data.status=="relogin")){
                    this.$message.error({message:"重新登录",duration:1600});
                    // //console.log(res.data.status=="relogin");
                    // that.removeInfo();
                }
            })
        },
       //分页
          handleCurrentChange(val) {
            this.page=val
            // //console.log(`当前页: ${val}`);
            localStorage.setItem('pagenum',this.page)
            this.getOrder ()
          },
    }
};
</script>

<style scoped lang="less">
.allOrder {
  width: 948px;
  background-color: #fff;
  .title {
    width: 100%;
    height: 55px;
    background-color: #fafafa;
    margin-bottom: 20px;
    font-size: 18px;
    padding-left: 20px;
    line-height: 55px;
    color: #0c69f5;
    box-sizing: border-box;
    span {
      cursor: default;
    }
  }
  .content{
      position: relative;
      width: 100%;
      min-height: 600px;
    //   border:1px solid red;
      .info{
        width: 100%;
        height: 35px;
        line-height: 35px;
        background-color: #AD0008;
        padding: 0 20px ;
        box-sizing: border-box;
        color:#fff;
        font-size:14px;
        overflow: hidden;
        display: flex;
            span{
                display:inline-block;
                overflow: hidden;
                text-align: center;
                text-overflow: ellipsis;
                white-space: nowrap;
                cursor: default;
                flex:1;
            //     &:nth-child(1){
            //         width: 22%;
            //     }
            //      &:nth-child(2){
            //         width: 22%;
            //     }
            //      &:nth-child(3){
            //         width: 12%;
            //     }
            //      &:nth-child(4){
            //         width: 12%;
            //     }
            //     &:nth-child(5){
            //         width: 12%;
            //     }
            //      &:nth-child(6){
            //         width: 20%;
            //     }

             }
      }
    //   .total{
    //       position: relative;
    //       width: 100%;
    //       min-height: 600px;
    //       background-color: #fff;
    //         ul{
    //              padding: 0 20px ;
    //           box-sizing: border-box;
    //         //   height: 600px;

    //         li{

    //           height: 40px;
    //           line-height: 40px;

    //               &:nth-child(2n){
    //                   background-color: #f4f4f4;
    //               }
    //           span{
    //             display:inline-block;
    //             overflow: hidden;
    //             text-align: center;
    //             text-overflow: ellipsis;
    //             white-space: nowrap;
    //             cursor: default;
    //             &:nth-child(1){
    //                 width: 22%;
    //             }
    //              &:nth-child(2){
    //                 width: 22%;
    //             }
    //              &:nth-child(3){
    //                 width: 12%;
    //             }
    //              &:nth-child(4){
    //                 width: 12%;
    //             }
    //             &:nth-child(5){
    //                 width: 12%;
    //             }
    //              &:nth-child(6){
    //                 width: 20%;
    //             }
    //              &.zhifu{
    //                 float: left;
    //                 color: #fe0000;
    //             }
    //             &.yizhifu{
    //                 float: left;
    //                 color: #006aca;
    //             }
    //                 &.type{
    //                 color: #333;
    //             }

    //         }





    //             }
    //         }
    //   }
      .block{
          text-align: center;
          position: absolute;
          bottom: 0;
          width: 100%;
          height: 52px;
      }
       .nodata{
            width: 212px;
            height: 240px;
            background-image: url('../assets/nodata.png');
            position: absolute;
            top:80px;
            left:40%;
       }
  }
}
.order_span{
    float: left;
}
.title {
  width: 100%;
  height: 55px;
  // margin-bottom: 20px;
  font-size: 18px;
  padding-left: 20px;
  line-height: 55px;
  color: #0c69f5;
  box-sizing: border-box;
  border-bottom: 2px solid #eee;
  span {
    margin-right: 20px;
    cursor: pointer;
    color: #b9b9b9;
  }
.curspan {
    border-bottom: 2px solid #AD0008;
    padding-bottom: 13px;
    color: #AD0008;
  }
}
.order_li{
    height: 190px;
    width: 900px;
    border:1px #eaeaea solid;
    margin: 10px auto;
    p:nth-child(1){
        height: 35px;
        width: 898px;
        background: #eee;
        line-height: 35px;
        span{
            margin-left: 10px;
        }
    }
    img{
        height: 140px;
        width: 200px;
        float: left;
        margin: 6px 10px;
    }
    div{
        float: left;
        div:nth-child(2){
            height: 150px;
            width: 200px;
            span:nth-child(1){
                font-size: 16px;
                margin-top:65px;
                display: block;
            }
            span:nth-child(3),span:nth-child(4){
                margin-top: 55px;
                display: inline-block;
            }
            span:nth-child(4){
                color:#f00;
            }
        }
        div:nth-child(3){
            width: 150px;
            height: 164px;
            color: #ad0008;
            font-size: 18px;
            text-align: center;
            line-height: 164px;
            border:#eaeaea 1px solid;
        }
        div:nth-child(4){
            width: 178px;
            text-align: center;
            height: 164px;
            line-height: 164px;
            border:1px #eaeaea solid;
            border-left: none;
        }div:nth-child(5){
            width: 150px;
            height: 164px;
            text-align: center;
            line-height: 164px;
            span{
                color: #138bef;
                display: block;
                height: 81px;
                line-height: 81px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/allOrder.vue